module.exports = __webpack_public_path__ + "img/QTUM.d0ef02cb.svg";